const PREAUTH_KEY = "preauth_session";

export const savePreauthSession = (data) => {
  const payload = {
    phoneNumber: String(data?.phoneNumber || "").trim().replace(/\D/g, ""),
    preauthToken: String(data?.preauthToken || "").trim(),
    name: String(data?.name || "").trim(),
    surname: String(data?.surname || "").trim(),
  };

  sessionStorage.setItem(PREAUTH_KEY, JSON.stringify(payload));
};

export const getPreauthSession = () => {
  try {
    const raw = sessionStorage.getItem(PREAUTH_KEY);
    if (!raw) {
      return {
        phoneNumber: "",
        preauthToken: "",
        name: "",
        surname: "",
      };
    }

    const parsed = JSON.parse(raw);

    return {
      phoneNumber: String(parsed?.phoneNumber || "").trim().replace(/\D/g, ""),
      preauthToken: String(parsed?.preauthToken || "").trim(),
      name: String(parsed?.name || "").trim(),
      surname: String(parsed?.surname || "").trim(),
    };
  } catch {
    return {
      phoneNumber: "",
      preauthToken: "",
      name: "",
      surname: "",
    };
  }
};

export const clearPreauthSession = () => {
  sessionStorage.removeItem(PREAUTH_KEY);
};